import { render, staticRenderFns } from "./IKP.vue?vue&type=template&id=4eddfdd8&scoped=true"
import script from "./IKP.vue?vue&type=script&lang=js"
export * from "./IKP.vue?vue&type=script&lang=js"
import style0 from "./IKP.vue?vue&type=style&index=0&id=4eddfdd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eddfdd8",
  null
  
)

export default component.exports